import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  templateUrl: './detalhes-super-social-modal.component.html',
  styleUrls: ['./detalhes-super-social-modal.component.scss'],
})
export class DetalhesSuperSocialModalComponent {
  constructor(
    private modalController: ModalController,
  ) { }

  async close() {
    await this.modalController.dismiss();
  }
}
